<template>
  <div class="page-stock">
    <landing-header />

    <main>
      <section class="hero-stock">
        <div class="max-w-7xl mx-auto px-4 flex flex-col lg:flex-row items-center gap-16">
          <div class="lg:w-1/2">
            <span class="badge-stock">Logistique & Inventaire</span>
            <h1 class="text-4xl md:text-6xl font-black text-gray-900 mb-6 leading-tight">
              Maîtrisez votre matériel, <br />
              <span class="gradient-text">du dépôt au camion</span>
            </h1>
            <p class="text-xl text-gray-600 mb-8 leading-relaxed">
              Fini les ruptures imprévues et les pièces égarées. Termoflow synchronise votre stock en temps réel avec l'activité terrain pour une rentabilité totale.
            </p>
            <div class="flex flex-wrap gap-4">
              <a href="/contact"><button class="btn-primary">Demander une démonstration</button></a>
              <a href="/fonctionnalites" class="btn-outline-large">Autres fonctionnalités</a>
            </div>
          </div>
          
          <div class="lg:w-1/2 w-full">
            <div class="stock-visual shadow-2xl">
              <div class="stock-header">
                <span class="location"><i class="fa-solid fa-truck"></i> Camion Thomas D.</span>
                <span class="status-live">Live Sync</span>
              </div>
              <div class="stock-list">
                <div class="stock-item">
                  <span class="name">Compresseur Scroll</span>
                  <span class="qty">2 unités</span>
                </div>
                <div class="stock-item consumed">
                  <span class="name">Fluide R32 (kg)</span>
                  <span class="qty">-2.5 kg</span>
                </div>
                <div class="stock-item">
                  <span class="name">Vanne d'arrêt</span>
                  <span class="qty">12 unités</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="py-20 bg-gray-900 text-white">
        <div class="max-w-7xl mx-auto px-4">
          <div class="text-center mb-16">
            <h2 class="text-3xl font-bold mb-4">Une visibilité multi-sites en temps réel</h2>
            <p class="text-gray-400">Suivez précisément vos actifs, peu importe où ils se trouvent.</p>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div class="loc-card">
              <i class="fa-solid fa-warehouse"></i>
              <h4>Stock Entrepôt</h4>
              <p>Gestion globale des arrivages et réapprovisionnements.</p>
            </div>
            <div class="loc-card active">
              <i class="fa-solid fa-truck-ramp-box"></i>
              <h4>Stock Camion</h4>
              <p>Inventaire embarqué par technicien pour une autonomie totale.</p>
            </div>
            <div class="loc-card">
              <i class="fa-solid fa-building-shield"></i>
              <h4>Stock Chantier</h4>
              <p>Suivi des pièces livrées et stockées directement chez vos clients.</p>
            </div>
          </div>
        </div>
      </section>

      <section class="py-24 bg-white">
        <div class="max-w-7xl mx-auto px-4 space-y-32">
          
          <div class="flex flex-col lg:flex-row items-center gap-16">
            <div class="lg:w-1/2">
              <h2 class="text-3xl font-bold text-gray-900 mb-6">Mouvements liés aux interventions</h2>
              <p class="text-gray-600 mb-6">Plus besoin de saisir vos sorties de stock en fin de journée. Chaque pièce déclarée sur l'application mobile déduit automatiquement le stock concerné.</p>
              <ul class="stock-benefits">
                <li><i class="fa-solid fa-circle-check"></i> Consommation réelle rattachée au technicien</li>
                <li><i class="fa-solid fa-circle-check"></i> Transferts simplifiés entre camion et dépôt</li>
                <li><i class="fa-solid fa-circle-check"></i> Traçabilité historique (date, lieu, intervenant)</li>
              </ul>
            </div>
            <div class="lg:w-1/2 bg-gray-50 p-12 rounded-[3rem] border border-gray-100">
               <div class="history-ui">
                  <div class="history-title">Historique des mouvements</div>
                  <div class="h-line"><span>14:02</span> - Thomas D. a consommé 1x Vanne</div>
                  <div class="h-line"><span>11:45</span> - Transfert Entrepôt > Camion Thomas</div>
               </div>
            </div>
          </div>

          <div class="flex flex-col lg:flex-row-reverse items-center gap-16">
            <div class="lg:w-1/2">
              <h2 class="text-3xl font-bold text-gray-900 mb-6">Le stock dans la poche du technicien</h2>
              <p class="text-gray-600 mb-6">Même sans réseau, vos équipes peuvent consulter leur inventaire embarqué et enregistrer leurs consommations. La synchronisation se fait dès le retour du signal.</p>
              <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div class="stat-box">
                  <span class="val">-15%</span>
                  <p>de pertes de matériel</p>
                </div>
                <div class="stat-box">
                  <span class="val">0</span>
                  <p>rupture imprévue</p>
                </div>
              </div>
            </div>
            <div class="lg:w-1/2 flex justify-center">
               <i class="fa-solid fa-mobile-button text-[140px] text-orange-500 opacity-20"></i>
            </div>
          </div>
        </div>
      </section>

      <section class="py-24 bg-gray-50">
        <div class="max-w-7xl mx-auto px-4 text-center">
          <h2 class="text-3xl font-bold text-gray-900 mb-12">Un pilotage basé sur la donnée réelle</h2>
          <div class="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div class="report-item">
              <i class="fa-solid fa-file-export"></i>
              <h4>Exports Inventaires</h4>
              <p>Préparez vos inventaires en un clic par localisation ou technicien.</p>
            </div>
            <div class="report-item">
              <i class="fa-solid fa-magnifying-glass-chart"></i>
              <h4>Anticipation des besoins</h4>
              <p>Identifiez les pièces à forte rotation pour optimiser vos achats.</p>
            </div>
            <div class="report-item">
              <i class="fa-solid fa-shield-halved"></i>
              <h4>Sécurité & Traçabilité</h4>
              <p>Une preuve irréfutable de chaque mouvement en cas d'audit ou de litige.</p>
            </div>
          </div>
        </div>
      </section>

      <section class="py-20 text-center">
        <div class="max-w-3xl mx-auto px-4">
          <h2 class="text-4xl font-black text-gray-900 mb-8">Reprenez le contrôle sur vos stocks</h2>
          <div class="flex flex-col sm:flex-row justify-center gap-4">
             <a href="/contact"><button class="btn-primary-large">Demander une démonstration</button></a>
             <a href="/fonctionnalites" class="btn-outline-large">Autres fonctionnalités</a>
          </div>
        </div>
      </section>

      <landing-roi />
      <landing-avis />
    </main>

    <landing-footer />
  </div>
</template>

<script>
import LandingHeader from './LandingHeader.vue'
import LandingFooter from './LandingFooter.vue'
import LandingAvis from './LandingAvis.vue'
import LandingROI from './LandingROI.vue'

export default {
  name: 'StockManagementPage',
  components: {
    LandingHeader,
    LandingFooter,
    LandingAvis,
    'landing-roi': LandingROI
  }
}
</script>

<style scoped>
/* --- TEXT UTILS --- */
.gradient-text {
  background: linear-gradient(to right, #f97316, #ef4444);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

/* --- HERO --- */
.hero-stock {
  padding: 10rem 0 6rem;
  background: radial-gradient(circle at top right, #fff7ed, transparent 35%);
}

.badge-stock {
  display: inline-block;
  padding: 0.5rem 1rem;
  background-color: #ffedd5;
  color: #c2410c;
  font-weight: 800;
  font-size: 0.75rem;
  border-radius: 9999px;
  margin-bottom: 1.5rem;
  text-transform: uppercase;
}

/* --- STOCK VISUAL --- */
.stock-visual {
  background: white;
  border-radius: 2rem;
  overflow: hidden;
  border: 1px solid #e5e7eb;
}
.stock-header {
  background: #f9fafb;
  padding: 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #e5e7eb;
}
.stock-header .location { font-weight: 800; color: #1f2937; }
.status-live { font-size: 0.6rem; background: #dcfce7; color: #166534; padding: 0.2rem 0.6rem; border-radius: 9999px; font-weight: 800; text-transform: uppercase; }

.stock-list { padding: 1.5rem; }
.stock-item {
  display: flex;
  justify-content: space-between;
  padding: 1rem 0;
  border-bottom: 1px solid #f3f4f6;
  font-weight: 700;
}
.stock-item.consumed { color: #ef4444; }
.stock-item .qty { font-family: monospace; }

/* --- LOCATION CARDS --- */
.loc-card {
  background: #1f2937;
  padding: 2.5rem;
  border-radius: 1.5rem;
  text-align: center;
  border: 1px solid #374151;
  transition: all 0.3s ease;
}
.loc-card.active { border-color: #f97316; box-shadow: 0 0 20px rgba(249, 115, 22, 0.1); }
.loc-card i { font-size: 2.5rem; color: #f97316; margin-bottom: 1.5rem; }
.loc-card h4 { font-weight: 800; margin-bottom: 1rem; font-size: 1.25rem; }
.loc-card p { color: #9ca3af; font-size: 0.9rem; }

/* --- HISTORY UI --- */
.history-ui { background: white; padding: 2rem; border-radius: 1.5rem; }
.history-title { font-weight: 900; font-size: 0.8rem; text-transform: uppercase; color: #9ca3af; margin-bottom: 1.5rem; }
.h-line { padding: 0.75rem 0; border-bottom: 1px solid #f3f4f6; font-size: 0.85rem; font-weight: 600; color: #4b5563; }
.h-line span { color: #f97316; font-weight: 800; }

/* --- BUTTONS --- */
.btn-primary { background: linear-gradient(to right, #f97316, #ef4444); color: white; padding: 1rem 2.5rem; border-radius: 9999px; font-weight: 700; border: none; }
.btn-primary-large { background: #f97316; color: white; padding: 1.2rem 3rem; border-radius: 9999px; font-weight: 800; border: none; font-size: 1.1rem; }
.btn-outline-large { border: 2px solid #e5e7eb; padding: 1.2rem 3rem; border-radius: 9999px; font-weight: 800; color: #1f2937; text-decoration: none; display: inline-block; }

/* --- MISC --- */
.stock-benefits { list-style: none; padding: 0; }
.stock-benefits li { display: flex; align-items: center; gap: 0.75rem; font-weight: 700; margin-bottom: 1rem; color: #4b5563; }
.stock-benefits li i { color: #f97316; }

.stat-box { background: #fff7ed; padding: 1.5rem; border-radius: 1rem; text-align: center; border: 1px solid #ffedd5; }
.stat-box .val { font-size: 2rem; font-weight: 900; color: #f97316; display: block; }
.stat-box p { font-weight: 700; font-size: 0.8rem; color: #c2410c; }

.report-item { padding: 2rem; }
.report-item i { font-size: 2.5rem; color: #f97316; margin-bottom: 1.5rem; }
.report-item h4 { font-weight: 800; margin-bottom: 1rem; }
.report-item p { color: #6b7280; font-size: 0.9rem; }

@media (max-width: 1024px) {
  .hero-stock { text-align: center; padding-top: 8rem; }
  .hero-stock .flex { flex-direction: column; }
  .stock-visual { margin-top: 4rem; }
}
</style>